import { render, staticRenderFns } from "./POType.vue?vue&type=template&id=778944db&"
import script from "./POType.vue?vue&type=script&lang=js&"
export * from "./POType.vue?vue&type=script&lang=js&"
import style0 from "./POType.vue?vue&type=style&index=0&id=778944db&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports